const SafeText = ({ text }) => {
  let lines;
  if (!text) return null;
  try {
    text = text.replace(/\\n/g, "\n");
  } catch (e) {
    console.error(e);
  }
  lines = text
    .split("\n")
    .map((line, index, array) =>
      index === array.length - 1 ? line : [line, <br key={index} />]
    );

  return <span>{lines}</span>;
};

export default SafeText;
